import React from "react"
import { View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseFontFamily } from "@Constants/baseStyles"
import { List } from "react-native-paper"
import SvgNext from "@Components/CustomIcon/SvgNext"
import IconeIvehteMissions from "@Components/CustomIcon/IconeIvehteMissions"
import IconeSuiviFichePatient from "@Components/CustomIcon/IconeSuiviFichePatient"
import IconeSuiviObjectifs from "@Components/CustomIcon/IconeSuiviObjectifs"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import CustomScrollableContentWithBackHeader from "@Components/CustomScrollableContentWithBackHeader/CustomScrollableContentWithBackHeader"

const AboutUs = (props) => {
    const { navigation } = props
    const rightIcon = () => <List.Icon style={{ paddingLeft: 40 }} icon={() => <SvgNext />} />
    const navigateTo = (nextScreen) => navigation.navigate(nextScreen)

    const accountItems = [
        {
            title: "Les missions d'IVEHTE",
            leftContent: <IconeIvehteMissions />,
            screen: "IvehteMissions"
        },
        {
            title: "L'équipe d'IVEHTE",
            leftContent: <IconeSuiviFichePatient />,
            screen: "IvehteTeam"
        },
        {
            title: "L'histoire d'IVEHTE",
            leftContent: <IconeSuiviObjectifs />,
            screen: "IvehteHistory"
        }
    ]

    return (
        <CustomScrollableContentWithBackHeader>
            <View style={styles.header}>
                <BreeSerifText style={styles.whoWeAre} fontSize={RFValue(24)}>
                    Qui sommes-nous ?
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                    Découvrez toute l’équipe d’IVEHTE, son histoire, ses missions.{" "}
                </OpenSansText>
            </View>
            <List.Section>
                {accountItems.map((item, index) => (
                    <View style={{ borderRadius: 10 }} key={index}>
                        <List.Item
                            style={styles.item}
                            title={item.title}
                            titleStyle={styles.title}
                            left={() => item.leftContent}
                            right={rightIcon}
                            onPress={() => navigateTo(item.screen)}
                        />
                    </View>
                ))}
            </List.Section>
        </CustomScrollableContentWithBackHeader>
    )
}

export default AboutUs
